var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:[
    { 'is-checked': _vm.checked },
    { 'is-modified': _vm.modified },
    { 'is-readonly': _vm.readonly },
    _vm.size
  ],attrs:{"aria-checked":_vm.checked,"role":"checkbox","tabindex":"0"},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.toggle($event)},"click":function($event){return _vm.toggle()}}},[(_vm.checked)?_c('font-awesome-icon',{attrs:{"icon":"check","size":"lg"}}):_c('span',[_vm._v(" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }